export default {
  title: 'Omat asiakirjat',
  description: 'Lataamasi yritysasiakirjat. Voit ladata tai korvata ne milloin tahansa.',
  document_types: {
    owner_document: 'Omistajan henkilöllisyystodistus',
    business_document: 'Yritysasiakirja',
  },
  kinds: {
    vat_registration: 'ALV-rekisteröinti',
    trade_registration: 'Kaupparekisteröinti',
    trade_license: 'Elinkeinolupa',
    commercial_register_extract: 'Kaupparekisteriote',
    financial_statements: 'Tilinpäätös',
    bank_statement: 'Tiliote',
    shareholder_list: 'Osakasluettelo',
    other: 'Muu',
    passport: 'Passi',
    driver_license: 'Ajokortti',
    id_card: 'Henkilökortti',
    residence_permit: 'Oleskelulupa',
  },
  sides: {
    front: 'Etupuoli',
    back: 'Takapuoli',
  },
  fields: {
    slot: 'Luokka',
    document: 'Asiakirja',
    kind: 'Laji',
    side: 'Puoli',
    uploaded_at: 'Ladattu',
    expires_at: 'Vanhenee',
    retained_until: 'Säilytetään asti',
    deleted_at: 'Poistettu',
    storage_deleted_at: 'Poistettu pysyvästi',
    actions: 'Toiminnot',
  },
  values: {
    no_slot: 'Muu',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Suodata asiakirjan tyypin mukaan',
    kind_placeholder: 'Suodata lajin mukaan',
  },
  retention: {
    deletable: 'Poistettavissa',
    tooltip:
      'Saksan laki (GoBD / §147 AO) edellyttää, että säilytämme tätä asiakirjaa {{date}} asti. Sen voi poistaa vasta kyseisen päivämäärän jälkeen.',
    tooltip_no_date: 'Tähän asiakirjaan sovelletaan lakisääteistä säilytysaikaa, eikä sitä voi vielä poistaa.',
  },
  buttons: {
    upload: 'Lataa',
    upload_other: 'Muu asiakirja',
    retry_slots: 'Asiakirjoja ei voitu ladata — yritä uudelleen',
    download: 'Lataa',
    download_front: 'Lataa etupuoli',
    download_back: 'Lataa takapuoli',
    reupload: 'Lataa uudelleen',
    delete: 'Poista',
  },
  empty: 'Et ole vielä ladannut asiakirjoja.',
  delete_modal: {
    title: 'Poista asiakirja',
    description:
      'Valitse, miten haluat poistaa tämän asiakirjan. ”Poista” arkistoi sen ja piilottaa sen luettelostasi. ”Poista pysyvästi” poistaa tiedostot lopullisesti, ja se on mahdollista vasta lakisääteisen säilytysajan päätyttyä.',
    delete: 'Poista',
    permanently_delete: 'Poista pysyvästi',
    cancel: 'Peruuta',
    retention_alert:
      'Näihin asiakirjoihin sovelletaan Saksan lain (GoBD / §147 AO) mukaisia lakisääteisiä säilytysaikoja. Asiakirjan poistaminen pysyvästi poistaa tiedostot peruuttamattomasti.',
  },
  reupload_modal: {
    title: 'Lataa asiakirja uudelleen',
    description: 'Lataa tästä asiakirjasta uusi versio. Edellinen versio korvataan.',
    type: {
      label: 'Asiakirjan tyyppi',
      placeholder: 'Valitse asiakirjan tyyppi',
    },
    kind: {
      label: 'Asiakirjan laji',
      placeholder: 'Valitse asiakirjan laji',
    },
    front: {
      label: 'Asiakirjan etupuoli',
    },
    back: {
      label: 'Asiakirjan takapuoli (valinnainen joissakin asiakirjoissa)',
    },
    expires_at: {
      label: 'Asiakirjan vanhenemispäivä',
      placeholder: 'Valitse vanhenemispäivä',
    },
    buttons: {
      select_file: 'Valitse tiedosto',
      submit: 'Lataa',
      cancel: 'Peruuta',
    },
  },
  toasts: {
    download_error: 'Asiakirjan lataaminen epäonnistui.',
    delete_success: 'Asiakirja poistettu onnistuneesti.',
    delete_error: 'Asiakirjan poistaminen epäonnistui.',
    reupload_success: 'Asiakirja ladattu onnistuneesti.',
    reupload_error: 'Asiakirjan lataaminen epäonnistui.',
  },
};
